import { FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Injectable, Renderer2 } from '@angular/core';

import swal from 'sweetalert2';
import { DatePipe } from "@angular/common";
import { Colaborador } from "@/store/catalogos/colaborador";

@Injectable({
  providedIn: 'root'
})
export class Util {

  constructor(
     private toastr: ToastrService
    ,private datePipe:DatePipe) {
  }

  public static validateReactiveField(campo: string, form: FormGroup) {
    return form.controls[campo].errors && form.controls[campo].touched;
  }

  public errorMessage(message: string) {
    this.toastr.error(message);
  }

  public successMessage(message: string) {
    this.toastr.success(message);
  }

  public puntearTexto(texto, longitud){
    return texto.length>=longitud;
    return texto;
  }

  public lpad(num:number, size:number): string {
    let s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

  public confirmMessage(message: string, do_) {
    swal.fire({
      title: message,
      showDenyButton: true,
      //showCancelButton: true,
      icon:'info',
      confirmButtonText: 'Si',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        //denyButton: 'order-3',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        do_();
        //swal.fire('Saved!', '', 'success')
      } //else if (result.isDenied) {
      //swal.fire('Changes are not saved', '', 'info')
      //}
    })
  }

  public infoMessage(title,message: string, do_) {
    swal.fire({
      title: title,
      html:message,
      //showDenyButton: true,
      //showCancelButton: true,
      confirmButtonText: 'Entendido',
      icon:'info',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        //denyButton: 'order-3',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        do_();
        //swal.fire('Saved!', '', 'success')
      } //else if (result.isDenied) {
      //swal.fire('Changes are not saved', '', 'info')
      //}
    })
  }
   
  public autoOcultarMenu(renderer: Renderer2){
    const autoOcultarMenu = JSON.parse(localStorage.getItem("autoOcultarMenu"));
    if(autoOcultarMenu){
        //renderer.removeClass(document.querySelector('app-root'),'sidebar-open');
        //renderer.addClass(document.querySelector('app-root'),'sidebar-collapse');
        this.ocultarMenu(renderer);
    }
  }
   
  public ocultarMenu(renderer: Renderer2){
      renderer.removeClass(document.querySelector('app-root'),'sidebar-open');
      renderer.addClass(document.querySelector('app-root'),'sidebar-collapse');
  }

  public isEmpty(val) {
    return val == undefined || val == null || val == "";
  }

  public isTrue(val){
    return val==true || val==1 || val=='1';
  }

  public nvl(val1, val2):any {
    return this.isEmpty(val1) ? val2 : val1;
  }

  public calcularIva(importe:number):any {
    return (importe*1.16)-importe;
  }

  public validaFecha(fecha: string): boolean {
    return fecha.match("[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{4}") != null;
  }
  // calcula la edad.
  public calculateAge(fechaNacimiento: Date): number {
    var timeDiff = Math.abs(Date.now() - fechaNacimiento.getTime());
    let age = Math.ceil((timeDiff / (1000 * 3600 * 24)) / 365);
    if(isNaN(age)){
      return null;
    }
    return age;
  }

  public static getNumbers(p: string) {
    return p?.replace(/[^0-9]+/g, "");
  }

  // cuenta los días habiles, no cuenta los 5 sabados y 6 domingos
  public workingDays(startingDate: Date, endDate: Date): number {
    let workingDays = 0;
    const day = 24 * 60 * 60 * 1000;
    while (startingDate <= endDate) {
      const week = startingDate.getDay();
      if (week !== 5 && week !== 6) {
        workingDays++;
      }
      startingDate.setTime(startingDate.getTime() + day);
    }
    return workingDays;
  }

  isValiField(field: string, form: FormGroup): boolean | null {
    return form.controls[field].errors
      && form.controls[field].touched;
  }

  getFieldError(field: string, form: FormGroup): string | null {
    if (!form.controls[field]) return null;
    const errors = form.controls[field].errors || {};

    for (const key of Object.keys(errors)) {
      switch (key) {
        case 'required':
          return 'Este campo es requerido';
        case 'minlength':
          return `Mínimo ${errors['minlength'].requiredLength} caracters.`;
      }

    }
  }

  toNumber(p:any):Number|null|undefined{
    return Number(p);
  }

  stringify(data){
    return JSON.stringify(data);
  }

  jsonParse(data){
    return JSON.parse(data);
  }

  isEmail(email: string):boolean {
    let isValid = false;
      'use strict';
      var REGEX = /^[a-zA-Z0-9.!#$%&’+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;
      if (email.match(REGEX)){
        isValid = true;
      }
    return isValid;
  }

  isRfc(rfc: string):boolean {
    let isValid = false;
      'use strict';
      var REGEX = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
      if (rfc.match(REGEX)){
        isValid = true;
      }
    return isValid;
  }

  normalize(str:string|undefined) {
    return this.nvl(str,"").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }



  
   getSesion():Colaborador{
     return JSON.parse(sessionStorage.getItem('colaborador'));
   }
  
  // setSesion(data:ColaboradorModel){
  //   sessionStorage.setItem("colaborador",JSON.stringify(data));
  // }

  horaSinSegundos(hora){
    if(this.isEmpty(hora)){
      return '';
    }
    return hora.substring(0,5);
  }
  

  ajustarYFormatearFecha(fecha: Date | string | null): Date | null {
    if (!fecha) {
      return null; 
    }
  
    const fechaObj = new Date(fecha); 
  
    if (isNaN(fechaObj.getTime())) {
      return null; 
    }

    const diferenciaHoraria = 6;
    const fechaAjustada = new Date(fechaObj.getTime() + diferenciaHoraria * 60 * 60 * 1000);
  
    return fechaAjustada; 
  }

  calculatePromedioYRango(values: number[]): { promedio: string, rango: string } {
    const promedio = (values.reduce((acc, val) => acc + val, 0) / values.length).toFixed(7);
    const mayor = Math.max(...values);
    const menor = Math.min(...values);
    const rango = (mayor - menor).toFixed(7);
  
    return { promedio, rango };
  }

  calculateAverage(lista: any[], property: string): number {
    const suma = lista.reduce((total, item) => {
      const valor = Number(item[property]);
      if (isNaN(valor)) {
        console.warn(`Valor inválido para ${property}: ${item[property]}`);
        return total;
      }
      return total + valor;
    }, 0);

    return lista.length > 0 ? suma / lista.length : 0;
  }

  obtenerSuma(lista: any[], campo: string): number {
    const total = lista.reduce((acc, item) => {
      const valor = parseFloat(item[campo]);
      return acc + (isNaN(valor) ? 0 : valor);
    }, 0);
    return parseFloat(total.toFixed(5));
  }
  

  promediarCampo(lista: any[], campo: string): number {
    if (!lista || lista.length === 0) return 0;
  
    const suma = lista.reduce((total, item) => {
      const valor = parseFloat(item[campo]) || 0;
      return total + valor;
    }, 0);
  
    const promedio = suma / lista.length;
    return parseFloat(promedio.toFixed(5));
  }

  diferenciaMaxMin(lista: any[], campo: string): number {
    if (!lista || lista.length === 0) return 0;
  
    const valores = lista
      .map(item => parseFloat(item[campo]))
      .filter(v => !isNaN(v));
  
    const max = Math.max(...valores);
    const min = Math.min(...valores);
  
    const diff = max - min;
    return parseFloat(diff.toFixed(6));
  }
  
  /**
 * Devuelve el número de semana ISO y el año en formato "ww/yy"
 * Ejemplo: "13/25" para 26 de marzo de 2025
 */
public getISOWeekAndYearString(fecha: Date | string): string {
  const date = new Date(fecha instanceof Date ? fecha.getTime() : fecha);

  const target = new Date(date);
  target.setDate(date.getDate() + 4 - (date.getDay() || 7)); // Ir al jueves

  const yearStart = new Date(target.getFullYear(), 0, 1);
  const week = Math.floor(((target.getTime() - yearStart.getTime()) / 86400000 + 1) / 7) + 1;
  const year = target.getFullYear().toString().slice(-2);

  return `${week}/${year}`;
}

}
